import Queries from '../queries';

const {
    GET_TARGET_OFFER,
} = Queries;

const Mutation = {
    setTargetOffer: (_root, { targetOffer = [] }, { client }) => {

        client.writeQuery({
            query: GET_TARGET_OFFER,
            data: {
                targetOffer: JSON.stringify(targetOffer),
            },
        });

        return null;

    },
};

export const resolvers = {
    Mutation,
};
